import script from "./TournamentSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./TournamentSetup.vue?vue&type=script&setup=true&lang=js"

import "./TournamentSetup.vue?vue&type=style&index=0&id=607ffdcd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-607ffdcd"]])

export default __exports__